<template>
  <div
    class="facet-count-card"
    :class="{ 'facet-count-card--outlined-left': outlinedLeft }"
    :style="{ width: width }"
    @click="handleClick"
  >
    <div class="facet-count-card__title">
      {{ displayLabel }}
    </div>
    <div class="facet-count-card__count">
      {{ count }}
    </div>
    <div v-if="subtext" class="facet-count-card__subtext">
      {{ subtext }}
    </div>
  </div>
</template>

<script>
  import { defineComponent } from 'vue'
  import TranslationsMixin from '../../util/TranslationsMixin'
  import FiltersMixin from '../../util/FiltersMixin'

  export default defineComponent({
    name: 'FacetCountCard',
    props: {
      facetName: {
        type: String,
        required: true
      },
      value: {
        type: [String, Number],
        required: true
      },
      label: {
        type: String,
        default: ''
      },
      count: {
        type: [String, Number],
        required: true
      },
      subtext: {
        type: String,
        default: ''
      },
      outlinedLeft: {
        type: Boolean,
        default: false
      },
      width: {
        type: String,
        default: '170px'
      }
    },
    emits: ['click'],
    computed: {
      displayLabel () {
        return (this.getLabelForTaxonomyValue(this.facetName, this.value) || this.label || this.value)
          .split('>')
          .slice(-1)[0]
          .trim()
      }
    },
    methods: {
      handleClick () {
        this.$emit('click', { facetType: this.facetName, value: this.value })
      }
    },
    mixins: [TranslationsMixin, FiltersMixin]
  })
</script>

<style scoped lang="scss">
  @import "../../../scss/variables.scss";

  .facet-count-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: var(--primary-extra-lightest);
    border: 1px solid white;
    border-radius: $default-border-radius;
    padding: 1rem;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    height: 150px;
    text-align: center;

    &--outlined-left {
      justify-content: flex-start;
      align-items: flex-start;
      text-align: left;
      padding: 1rem 1.5rem;

      .facet-count-card__title {
        margin-bottom: 0.5rem;
      }

      .facet-count-card__count {
        font-size: 1.8rem;
        margin-bottom: 0.5rem;
      }

      .facet-count-card__subtext {
        font-size: 0.875rem;
        color: #666;
      }
    }

    &:hover {
      background-color: #f7f7f7;
      border: 1px solid #f7f7f7;
    }

    &__title {
      text-transform: uppercase;
      font-family: $font-stack-secondary;
      font-size: 12px;
      margin-bottom: 10px;
    }

    &__count {
      font-size: 55px;
      margin-bottom: 5px;
    }

    &__subtext {
      font-size: 12px;
      color: #666;
    }
  }
</style>
